import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { TripsheetInputFilter } from "domain/models/tripsheet-input-filter";
import { Vacation } from "domain/entities/vacations";
import { IVacationRepository } from "domain/contracts/vacation.contract";
import { formatDate } from "presentation/utils/formatEndDate";
import { VacationInputFilter } from "domain/models/vacation-input-filter";

class VacationsRepository implements IVacationRepository {
  async create(input: Vacation): Promise<Message<Vacation>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };

    const response = await httpClient.post(`/vacationPlan`, { data: newInput });
    return response.data;
  }

  async getAll(filter?: VacationInputFilter): Promise<Message<Vacation[]>> {
    const response = await httpClient.get(`/vacationPlan`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Vacation>> {
    const response = await httpClient.get(`/vacationPlan/${id}`);
    return response.data;
  }

  async update(input: Vacation): Promise<Message<boolean>> {
    const response = await httpClient.put(`/vacationPlan/${input.id}`, {
      data: { status: input.status, rejectionReason: input.rejectionReason },
    });
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/vacationPlan/${id}`);
    return response.data;
  }
}

export default new VacationsRepository();
